import type { ReactNode, JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';

export interface FormFieldsetProps
    extends CommonProps,
        VariantProps<typeof FormFieldsetStyles> {
    children?: ReactNode;
    title: string;
}

export const FormFieldsetStyles = tv({
    slots: {
        root: '',
        legend: 'xs:text-xl xs:leading-6 mb-1 text-lg leading-6 md:text-2xl font-bold',
        group: 'flex flex-col gap-1',
    },
    variants: {},
});

export const FormFieldset = ({
    className,
    children,
    title,
    testId = 'form-fieldset',
    ...props
}: FormFieldsetProps): JSX.Element => {
    const { root, group, legend } = FormFieldsetStyles();
    return (
        <fieldset
            className={root({ className })}
            {...props}
            data-testid={testId}
        >
            <legend className={legend()}>{title}</legend>
            <div className={group()}>{children}</div>
        </fieldset>
    );
};
